<template lang="pug">
  .access.user-update.thread-edit
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :hideDeleteButton="(!!fields.id)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.modal__title {{formTitle}}
      slot
        e-form(:formValidator="formValidator" formClass="modal__body")
          // ОБЩИЕ СВЕДЕНИЯ
          .body.display-block
            .top
              div
                e-form-group.year-field(
                  inputType= 'dsd'
                  label="Год"
                  tabView='tab'
                  name = 'year'
                )
                  el-input-number(v-model='fields.year' )
              .subject-name
                e-form-group.mo-search.thread-edit__geo-object(
                  inputType="suggestion"
                  :suggestionEndpoint='getMOEndpoint'
                  :model='fields'
                  tabView='tab'
                  name = 'geoName'
                  @selectItem="selectMoItemEvnt"
                  @change='moItemChangeEvnt'
                  :addBorder="true"
                  label="Наименование геообъекта..."
                  :useInnerSearch="false"
                  @clear=''
                )
                button.button.button_width-auto.subject-name__button(@click="toMap('geo')") Выбрать объект на карте
              .visible-thread
                .col.col-block
                  .custom-checkbox
                    input.visually-hidden.custom-checkbox__input(type="checkbox" id="checkbox-view" v-model='fields.active')
                    label.legend__label.custom-checkbox__label(for="checkbox-view" )
                      span.custom-checkbox__block
                      span Видимость потока на карте
          .comments(v-if='fields.comment').display-block
            ul
              li(v-for='com in fields.comment') {{com}}
          .thread-tko-elements.thread-edit__row(
            v-for="p in sortedPoints"
            :data-delta="p.delta"
            :key="p.delta"
          )
            .thread-edit__col.thread-edit__info
              .thread-point-element(
                @click='changeType(p)'
                v-bind='pointProps(p.color_key)'
              )
              .point-name.thread-edit__point-name Плечо \#{{p.delta}}
              .mover
                el-button.thread-edit__button(icon='el-icon-arrow-up' sizee='mini' ':disabled'='p.delta == 1' title='поднять на 1' @click='moveTKKOshka(p,"up")' )
                el-button.thread-edit__button(icon='el-icon-arrow-down' sizee='mini' ':disabled'='p.delta == sortedPoints.length' title='опустить на 1' @click='moveTKKOshka(p,"down")')
            .col.thread-edit__col.thread-edit__col_wide(v-if="hasAtuThreadsField")
              e-form-group.tko-search(
                inputType="suggestion"
                :suggestionEndpoint='getMOEndpoint'
                tabView='tab'
                label="Геообъект"
                :model='p'
                :disabled="Boolean(p.tko_name)"
                name = 'geo_name'
                @selectItem="selectTkoItemEvnt(p, 'geo_object', $event)"
                @change="tkoItemChangeEvnt(p, 'geo_object')"
                :addBorder="true"
                placeholder='Наименование геообъекта...'
                :useInnerSearch="false"
              )
            .col.thread-edit__col.thread-edit__col_wide
              div
                e-form-group.tko-search(
                  inputType="suggestion"
                  :suggestionEndpoint='getTKOEndpoint'
                  tabView='tab'
                  :label="constants.tkoFieldTitle"
                  :model='p'
                  :disabled="Boolean(p.geo_name)"
                  name = 'tko_name'
                  @selectItem="selectTkoItemEvnt(p, 'tko_object', $event)"
                  @change="tkoItemChangeEvnt(p, 'tko_object')"
                  :addBorder="true"
                  placeholder='Наименование ТКО-объекта...'
                  :useInnerSearch="false"
                )
                .thread-edit__buttons
                  button.button.button_width-auto(@click="toMap('object', p.delta)" v-if="!Boolean(p.geo_name)" ) Выбрать объект на карте
                  button.button.button_width-auto(v-if="p.delta===1 && fields.geo_object_id" @click='toAtu' ) Компонентный состав отходов в потоке
                  button.button.button_width-auto(v-if="p.delta!=1 && p.tko_name" @click='toTkoObject(p.object_id)' ) Компонентный состав отходов в плече
            .col.thread-edit__col
              e-form-group(
                name="size_tonn"
                formGroupStyle="col-block form-group__item thread-edit__form-item"
                inputType="input"
                label="Масса отходов, тонн"
                :model="p"
                tabView='tab'
                autocomplete="off"
              )
            .col.thread-edit__col
              e-form-group(
                name="distance"
                formGroupStyle="col-block form-group__item thread-edit__form-item"
                inputType="input"
                label="Расстояние до объекта, км"
                :model="p"
                tabView='tab'
                autocomplete="off"
                :disabled="true"
              )
          .button-wrapper.display-block
            button.button.button_blue(@click="createNewEdge") Добавить плечо

    el-dialog(
      v-if='threadPointObjToColorSet != null'
      title="Замена цвета(типа) стрелки"
      width="30%"
      ':visible'='true'
      @close='threadPointObjToColorSet=null'
      ':append-to-body'='true'
    )
      el-radio-group(v-model='threadPointObjToColorSet.color_key')
        el-radio-button(
          v-for='(title, key) in constants.pointTypes'
          :label="key" :key="key" :value="key"
        ) {{title}}
</template>
<script>
import { atu, core, access, threads, tko } from '@/api/api-endpoints'
import hasMixin from '@/mixins/has-mixin'
import url from '@/utils/url'
import adminForm from './mixins/admin-form'

export default {
  mixins: [adminForm, hasMixin],
  data() {
    return {
      threadPointObjToColorSet: null,
      fields: {
        geo_object_id: null,
        geoName: '',
        year: 0,
        points: [],
      },
      errors: null,
      selectedGeoName: null,
      selectedGeoId: null,
      threadConstants: { pointTypes: null, pointTypesColors: null },
    }
  },
  computed: {
    constants() {
      return this.threadConstants
    },
    sortedPoints() {
      if (!this.fields.points.length) {
        let points = []

        this.$set(this.fields, 'points', points)
      }
      this.fields.points.map((item) => {
        item.geo_name = null
        item.tko_name = null
        switch (item.object_type) {
          case 'tko_object':
            item.tko_name = item.object_name
            break
          case 'geo_object':
            item.geo_name = item.object_name
            break
        }
      })
      return this.fields.points.sort((a, b) => {
        if (a.delta > b.delta) return 1
        if (a.delta < b.delta) return -1
        return 0
      })
    },
    formTitle() {
      if (this.fields && this.fields.geo_object_id) {
        return 'Редактирование потока из "' + this.fields.geoName + '"'
      }
      return this.$translate('Новый поток')
    },
  },
  methods: {
    // назначение стилей для отрисовки точки ..
    pointProps(pointType) {
      let props = {}
      if (!pointType) {
        return props
      }
      if (this.threadConstants.pointTypesColors) {
        props.style = {
          background: '#' + this.threadConstants.pointTypesColors[pointType],
        }
      }
      if (this.threadConstants.pointTypes) {
        props.title = this.threadConstants.pointTypes[pointType]
      }
      return props
    },
    // изменение типа стрелки ...
    changeType(point) {
      this.threadPointObjToColorSet = point
    },
    // выбран из списка геообъект МО
    selectMoItemEvnt(e) {
      this.fields.geoName = e.name
      this.fields.geo_object_id = e.id
    },
    //выбран объект ТКО
    selectTkoItemEvnt(p, type, obj) {
      p.object_id = obj.id
      switch (type) {
        case 'tko_object':
          p.tko_name = obj.name
          p.geo_name = null
          p.object_type = 'tko_object'
          break
        case 'geo_object':
          p.geo_name = obj.name
          p.tko_name = null
          p.object_type = 'geo_object'
          break
      }
      this.$forceUpdate()
    },
    tkoItemChangeEvnt(p, type) {
      switch (type) {
        case 'tko_object':
          if (!p.tko_name) {
            p.object_id = null
            p.tko_name = null
          } else {
            p.geo_name = null
          }
          break
        case 'geo_object':
          if (!p.geo_name) {
            p.object_id = null
            p.geo_name = null
          } else {
            p.tko_name = null
          }
          break
      }
      this.$forceUpdate()
    },
    moItemChangeEvnt() {
      if (!this.fields.geoName) {
        this.fields.geo_object_id = null
      }
    },
    getMOEndpoint(model, q) {
      return atu.atuObjects({
        query: { 'per-page': -1, q },
      })
    },
    getAtuEndpoint(model, q) {
      return core.collection('region', {
        query: { 'per-page': -1, q },
      })
    },
    getTKOEndpoint(model, q) {
      return tko.objectSimple({ query: { q } })
    },
    // относительное перемещение ткошек ..
    moveTKKOshka(point, direction) {
      let newDelta = point.delta
      let oldDelta = point.delta
      let point2
      switch (direction) {
        case 'up':
          newDelta--
          break
        case 'down':
          newDelta++
          break
      }
      for (let i = 0; i < this.fields.points.length; i++) {
        if (this.fields.points[i].delta === newDelta) {
          point2 = i
          break
        }
      }
      if (typeof point2 != 'undefined') {
        this.$set(this.fields.points[point2], 'delta', oldDelta)
        point.delta = newDelta
      }
    },
    update() {
      adminForm.methods.update.call(this)
    },
    // send post for correct change status and avatar
    getStoreAction() {
      return 'createModel'
    },
    getRolesUrl() {
      return access.groups()
    },
    getDeleteUrl(id) {
      return access.userDelete(id)
    },
    getUpdateOrCreateUrl() {
      return threads.one(this.$route.params.id)
    },
    getItemEndpoint(route) {
      if (!route.params.id) {
        return null
      }
      return threads.one(route.params.id)
    },
    transformFieldsBeforeSend() {
      let points = [...this.fields.points]
      points = points
        .map((item) => {
          return {
            object_id: item.object_id,
            object_type: item.object_type,
            size_tonn: item.size_tonn,
            color_key: item.color_key,
            delta: item.delta,
          }
        })
        .filter((item) => {
          if (item.object_id) {
            return item
          }
        })
      delete this.fields.geoName
      this.fields.points = points
    },
    createNewEdge() {
      this.fields.points.push({
        color_key: null,
        delta: this.fields.points.length + 1,
        distance: null,
        id: null,
        size_cub: null,
        size_tonn: null,
        tko_object_id: null,
      })
    },
    // переход на карту для выбора района
    toMap(type, delta) {
      let route = this.$route
      route.params.selectedType = type
      route.params.thread_id = this.$route.params.id
      route.params.threadYear = this.fields.year
      if (delta) {
        route.params.delta = delta
      }
      route = url.getRoute(route, true)
      this.$router.push({
        name: 'geo.objects',
        query: {
          prevRoute: route,
        },
      })
    },
    // получение района из роута
    getObjectFromRoute() {
      let usedRoute = url.getPrevOrCurrentRoute(this.$route)
      if (usedRoute.params.selectedGeoId) {
        this.fields.geoName = usedRoute.params.selectedGeoName
        this.fields.geo_object_id = usedRoute.params.selectedGeoId
      }
      if (usedRoute.params.threadYear) {
        this.fields.year = usedRoute.params.threadYear
      }

      if (usedRoute.params.deltas) {
        for (const [key, value] of Object.entries(usedRoute.params.deltas)) {
          const delta = this.fields.points.find(
            (item) => item.delta === Number(key)
          )
          if (delta) {
            delta.object_name = value.selectedObjectName
            delta.object_id = value.selectedObjectId
          } else {
            this.fields.points.push({
              delta: Number(key) + 1,
              object_name: value.selectedObjectName,
              object_id: value.selectedObjectId,
              object_type: 'tko_object',
            })
          }
        }
        this.$forceUpdate()
      }
    },
    async getThreadConstants() {
      let endpoint = threads.constants()

      const data = await this.$store.dispatch('updateUrlEndpoint', {
        endpoint,
      })
      this.threadConstants = data.data
    },
    toAtu() {
      let route = this.$route
      route = url.getRoute(route, true)

      this.$router.push({
        name: 'atu.objects.update',
        params: {
          id: this.fields.geo_object_id,
        },
        query: {
          tabView: 'garbage',
          selectList: 'waste-generation',
          prevRoute: route,
        },
      })
    },
    toTkoObject(id) {
      let route = this.$route
      route = url.getRoute(route, true)
      this.$router.push({
        name: 'registry.objects.update',
        params: {
          id,
        },
        query: {
          tabView: 'tab5',
          selectList: 'wasteTails',
          prevRoute: route,
        },
      })
    },
  },
  created() {
    this.getThreadConstants()
    if (!this.fields.year) {
      let date = new Date()
      this.$set(this.fields, 'year', date.getFullYear())
    }
    this.getObjectFromRoute()
  },
  mounted() {
    this.createNewEdge()
  },
}
</script>
<style lang="scss">
.thread-point-element {
  width: 1.5em;
  border: 1px solid #ddd;
  border-radius: 0.25em;
  cursor: pointer;
}

.thread-tko-elements .point-name {
  transform: rotate(-90deg);
  align-self: center;
  height: 1px;
}

.mo-search,
.tko-search {
  height: unset;
}

.thread-tko-elements .body {
  margin: 0.5em 0;
  padding: 0;
}

.mover {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.mover button {
  padding: 0.5em;
}

.mover i {
  height: auto;
  width: auto;
  margin: 0;
}

.top {
  display: flex;
  gap: 20px;
  flex-grow: 1;
}

.subject-name {
  display: flex;
  align-items: flex-end;
  flex-grow: 1;
  gap: 10px;

  .mo-search.e-form-group.col-block {
    max-width: 300px;
  }

  &__button {
    margin-bottom: 20px !important;
  }
}

.visible-thread {
  justify-self: flex-end;
}

.main-layout .body_left {
  padding-left: 165px;
}

.col_max {
  max-width: calc(33% - 40px);
}

.button-wrapper {
  padding: 20px;
}

.thread-edit {
  &__buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 20px;
  }
}
</style>
